import BigNum from "../../math/BigNum";

export default class UpgradeCostCalculator {
    /**
     */
    constructor() {
    }

    /**
     * @abstract
     * @param {number} currentPurchaseCount 
     * @param {BigNum} out The output param
     */
    getNextPurchaseCost(currentPurchaseCount, out) {
    }

    /**
     * @abstract
     * @param {BigNum} singlePurchaseCost The cost of purchasing a single building.
     * @param {number} numberToPurchase   Must be greater than 1.
     * @param {BigNum} out The output param
     * @returns {BigNum}
     */
    calculateBulkPurchaseCost(singlePurchaseCost, numberToPurchase, out) {        
    }

    /**
     * Returns the number of upgrades that can be purchased based on how much money we have.
     * @abstract
     * @param {BigNum} money The total amount of money the player has.
     * @param {BigNum} singlePurchaseCost The cost of purchasing a single upgrade.
     * @return {number}
     */
    calculateMaxAffordable(money, singlePurchaseCost) {
        return 0;
    }
    
}